module.exports = __webpack_public_path__ + "032b93d302485f0c98d2e205da257562.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/party-hat-s.png
// module id = 2932
// module chunks = 0